//React
import React from "react";


//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as memoAction from '../action/memoAction';
//Material-ui
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
//Add
import axios from 'axios';
import config from '../config';

//Part
import PartPageTitle from './PartPageTitle';
import PartUrl2Button from './PartUrl2Button';
//Icon
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';



class Comp extends React.Component {

  constructor(props) {
    super(props);
  	this.state = {
      pageTitle: null,
      helpList: [],
      helpVisible: false,
      categoryChild: [],
  	}
  }

  componentDidMount() {
    document.title = 'ヘルプ - パートナーズ';
    this._helpGet();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this._helpGet();
    }
  }

  _helpGet() {
    let type;
    let filter;
    let category = this.props.match.params.category;
    let id = this.props.match.params.id;
    if (category) {
      type = 'category';
      filter = category;
    }
    else if (id) {
      type = 'id';
      filter = id;
    }

    const params = new URLSearchParams();
    params.append('type', type);
    params.append('filter', filter);
    return axios.post(config.apiUri + "helpApi.php", params, {
      timeout: 10000,
    })
    .then((res) => {
      this.setState({
        pageTitle: res.data.title,
        helpList: res.data.list,
        categoryChild: res.data.category_child,
      });
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }


  _renderList(value, index, arr) {
    return (

      <div key={index}>
        <div
          onClick={ () => this._answerVisibleToggle(index) }
          style={{
            fontSize:'1.2em',
            fontWeight:'bold',
            padding:'5px',
            cursor: 'pointer',
          }}
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'left',
              justifyContent:'space-between',
            }}
          >
            <div>
              {value.question}
            </div>
            <div>
            {
              (value.answerVisible) ?
              <ArrowDropDownIcon /> :
              <ArrowRightIcon />
            }
            </div>
          </div>


        </div>
        {
          (value.answerVisible) &&
          <div style={{margin:'5px', color:'#333', whiteSpace: 'pre-line'}}>
            {
              (value.type === 'html') ? (
                <div
                  dangerouslySetInnerHTML={{__html: value.answer}}
                />
              ): (
                <PartUrl2Button text={value.answer} />
              )
            }
          </div>
        }
        {
          (arr.length - 1 > index) &&
          <Divider />
        }
      </div>
    )
  }

  _answerVisibleToggle(index) {
    let newHelpList = Object.assign([], this.state.helpList);
    if (newHelpList[index].answerVisible === true) {
      newHelpList[index].answerVisible = false;
      this.setState({helpList: newHelpList})
    }
    else {
      newHelpList[index].answerVisible = true;
      this.setState({helpList: newHelpList})
    }
  }


  _renderCategoryChild(value, index, arr) {
    return (
      <span key={index} style={{margin:'3px'}}>
        <Button
          variant="outlined"
          color="primary"
          onClick={ () => this.props.history.push('/help/category_' + value.help_category_name_en) }
        >
          {value.help_category_name}
        </Button>
      </span>
    )
  }

	render() {
		return (
      <div>
        <PartPageTitle
          title={ this.state.pageTitle }
          onback={ '/help/' }
        />

        <div style={{maxWidth:'600px', margin:'auto'}}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
          {
            this.state.categoryChild.map(
              (value, index, arr) => this._renderCategoryChild(value, index, arr)
            )
          }
          </div>

          {
  					this.state.helpList.map(
            	(value, index, arr) => this._renderList(value, index, arr)
          	)
  				}
      	</div>

      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {

	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...memoAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
